module.exports = __webpack_public_path__ + "static/media/progress-post-stage.05cc17d3.png";